<template>
	<div class="w100" v-if="$route.meta.type!='login'">
		<!-- <Header class="w100"></Header>
        <Menu></Menu> -->
		<div class="container">
			<transition :name="transitionName">
				<keep-alive :include="keepAlive">
					<router-view class="Router"></router-view>
				</keep-alive>
			</transition>
			<!-- <router-view /> -->
		</div>
	</div>
	<div class="login w100" v-else>
		<router-view />
	</div>
</template>
<!-- ios禁止缩放 -->
<script>
    window.onload = function() {
        document.addEventListener('touchstart', function(event) {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        })
        document.addEventListener('gesturestart', function(event) {
            event.preventDefault()
        })
    }
</script>
<script>
	export default {
		components: {
		},
		data() {
			return {
				keepAlive: 'main-keep-alive',  //需要缓存的页面 例如首页
				transitionName: 'slide-right', //初始过渡动画方向
				defined: {
				}
			}
		},
		methods: {
			getUserAgent() {
				if (navigator.userAgent.split(";")[1] == " MSIE 9.0") {
					this.$alert('为了给您提供更好的服务，建议您使用IE9以上浏览器进行访问');
				}
			},
	},
		mounted() {
			this.$store.dispatch("getUserInfo");
		},
		watch: {
			$route(to, from) {
				// 切换动画
				let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
				if (isBack) {
					this.transitionName = 'slide-left'
				} else {
					this.transitionName = 'slide-right'
				}
				this.$router.isBack = false
			}
		}
	}
</script>
<style>
	/* #app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		width: 100%;
		height: 100%;
		max-width: 15rem;
		margin: auto;
		position: relative;

	} */

	.Router {
		position: absolute;
		height: 100%;
		transition: all .377s ease;
		/* will-change: transform; */
		top: 0;
		backface-visibility: hidden;
		/* perspective: 1000; */
	}

	.slide-left-enter,
	.slide-right-leave-active {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	.slide-left-leave-active,
	.slide-right-enter {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}
</style>